<div class="container  app__component">
    <h1 class="heading">
        <ng-container i18n>Order line fields</ng-container>
        <small *ngIf="loading && orderLineFields" class="text-muted" i18n>Loading...</small>
    </h1>

    <app-loader *ngIf="!orderLineFields" class="text-muted" i18n>Loading...</app-loader>

    <p *ngIf="orderLineFields">
        <a class="btn  btn-primary  button  button--add-to-table" href="javascript:" (click)="add()" i18n>Add order line field</a>
    </p>

    <app-table *ngIf="orderLineFields" [autoSizeLastColumn]="true">
        <thead>
        <tr>
            <th i18n>Name</th>
            <th style="width: 60px;"></th>
        </tr>
        </thead>

        <tbody>
        <ng-template ngFor let-orderLineField [ngForOf]="orderLineFields" let-i="index">
            <tr>
                <td>
                    <fa-icon [ngbTooltip]="'Localizations missing'" *ngIf="!missingLocalizations[i].complete" [icon]="faExclamation"></fa-icon>
                    {{ orderLineField.name }}
                    <span class="badge  badge-secondary" style="transform: translateY(-1px);">{{ orderLineField.type }}</span>
                </td>
                <td class="text-right">
                    <a href="javascript:" (click)="edit(orderLineField, i)" i18n>Edit</a>
                    <a href="javascript:" (click)="delete(orderLineField)" class="text-danger" i18n>Delete</a>
                </td>
            </tr>
        </ng-template>
        </tbody>
    </app-table>
</div>
